<template>
  <div class="chat-messages f--1 pl-15px pr-10px" ref="messagesContainer">
    <ChatMessageItem v-for="message in messages" :key="message.id" :message="message" />
    <LoadingIndicator :loading="loading" />
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from "vue";
import ChatMessageItem from "@/views/ReportDetailsView/components/ReportChat/ChatMessageItem.vue";
import LoadingIndicator from "@/views/ReportDetailsView/components/ReportChat/LoadingIndicator.vue";

const props = defineProps({
  messages: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const messagesContainer = ref(null);

watch(
  () => props.messages.length,
  async () => {
    await nextTick();
    if (messagesContainer.value) {
      messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
    }
  }
);
</script>

<style lang="scss" scoped>
.chat-messages {
  overflow-y: auto;
  border-top: 1px solid $color-grey-1;
  border-bottom: 1px solid $color-grey-1;
}
</style>
